import React, { createContext, useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';

interface DevModeContextType {
  switchScenario: (category: string, value: string) => void;
}

const DevModeContext = createContext<DevModeContextType | undefined>(undefined);

export function DevModeProvider({ children }: { children: React.ReactNode }) {
  const queryClient = useQueryClient();

  const switchScenario = (category: string, value: string) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(`DEV_PREVIEW:scenario:${category}`, value);

      // WHY: queryClient.clear() safely dumps persona state bleedovers during swaps
      if (category === 'persona') {
        window.location.reload();
      } else {
        queryClient.invalidateQueries();
      }
    }
  };

  return <DevModeContext.Provider value={{ switchScenario }}>{children}</DevModeContext.Provider>;
}

export function useDevMode() {
  const context = useContext(DevModeContext);
  if (context === undefined) {
    throw new Error('useDevMode must be used within a DevModeProvider');
  }
  return context;
}
